import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import TextField from '@material-ui/core/TextField';

const UserInfo = ({ formik }) => {

	const toUpperCase = (event) => {
		if (event.target.value) {
			formik.setFieldValue(event.target.name, event.target.value.toUpperCase());
		} else {
			formik.handleChange(event);
		}

	};

	return (
		<Box display='flex'>
			<Box p={2}>
				<TextField
					label='UserID'
					name='userID'
					variant='outlined'
					value={formik.values.userID}
					onChange={toUpperCase}
					error={formik.touched.userID && Boolean(formik.errors.userID)}
					onBlur={() => formik.setFieldTouched('userID', true)}
					helperText={formik.touched.userID && formik.errors.userID}
					inputProps={{ maxLength: 5 }}
					fullWidth
				/>
			</Box>

			<Box p={2} >
				<TextField
					label='Last 4 SSN'
					name='lastFour'
					variant='outlined'
					value={formik.values.lastFour}
					onChange={formik.handleChange}
					error={formik.touched.lastFour && Boolean(formik.errors.lastFour)}
					onBlur={() => formik.setFieldTouched('lastFour', true)}
					helperText={formik.touched.lastFour && formik.errors.lastFour}
					inputProps={{ maxLength: 4 }}
					fullWidth
					type='password'
				/>
			</Box>

		</Box>

	);
};

UserInfo.propTypes = {
	formik: PropTypes.any
};
export default UserInfo;